import { render } from "./x-lg.vue?vue&type=template&id=55a62c5a"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/x-lg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55a62c5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55a62c5a', __exports__)) {
    api.reload('55a62c5a', __exports__)
  }
  
  module.hot.accept("./x-lg.vue?vue&type=template&id=55a62c5a", () => {
    api.rerender('55a62c5a', render)
  })

}


export default __exports__